var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExit = function SvgExit(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.138 8.47132C15.3983 8.21097 15.3983 7.78886 15.138 7.52851L11.4713 3.86185C11.211 3.6015 10.7889 3.6015 10.5285 3.86185C10.2682 4.1222 10.2682 4.54431 10.5285 4.80466L13.7238 7.99992L10.5285 11.1952C10.2682 11.4555 10.2682 11.8776 10.5285 12.138C10.7889 12.3983 11.211 12.3983 11.4713 12.138L15.138 8.47132Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7.99992C5 8.37068 5.29717 8.66659 5.66375 8.66659L13.6696 8.66659C14.0334 8.66659 14.3333 8.36811 14.3333 7.99992C14.3333 7.62916 14.0362 7.33325 13.6696 7.33325L5.66375 7.33325C5.29997 7.33325 5 7.63173 5 7.99992Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33325 14.6666C9.33325 14.2984 9.03478 13.9999 8.66659 13.9999L2.33618 13.9999C2.14971 13.9999 1.99992 13.8494 1.99992 13.6644L1.99992 2.33542C1.99992 2.1499 2.14945 1.99992 2.33618 1.99992L8.66659 1.99992C9.03478 1.99992 9.33325 1.70144 9.33325 1.33325C9.33325 0.965063 9.03478 0.666586 8.66659 0.666586L2.33618 0.666586C1.41511 0.666586 0.666586 1.41148 0.666586 2.33542L0.666586 13.6644C0.666586 14.5864 1.41386 15.3333 2.33618 15.3333L8.66659 15.3333C9.03478 15.3333 9.33325 15.0348 9.33325 14.6666Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exit.ddfafbff.svg";
export { ForwardRef as ReactComponent };